export default {"src":"/_next/static/media/caret-down.5347c286.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};